var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 255,
    viewBox: "0 0 160 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1137 216.566C34.8499 215.2 28.7797 213.061 23.042 210.201",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.983 215.405C96.0069 220.318 70.5934 221.552 49.3672 218.172",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.712 168.112C154.223 172.751 158.272 178.793 158.272 186.466C158.272 198.075 144.791 207.224 125.856 213.025",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.314 128.233C148.318 133.969 154.361 141.044 154.208 148.991C153.853 167.821 122.67 187.087 84.2518 187.087C62.0735 187.087 43.9696 182.714 43.655 170.226C43.3404 157.737 71.0046 155.599 88.9392 155.236C107.495 154.856 129.076 157.696 143.162 165.296",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.446 135.356C99.159 136.759 90.7824 137.568 82.3799 137.777C62.0653 138.269 29.286 133.743 30.2299 124.352C31.1738 114.961 62.7026 112.791 84.2838 112.791C105.865 112.791 118.168 115.824 133.005 123.408",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.363 94.2271C143.312 96.107 144.87 98.3533 145.949 100.837C147.027 103.321 147.605 105.993 147.648 108.701C147.841 121.754 133.352 129.427 116.184 133.582",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7363 79.8988C57.7323 77.6479 71.9395 76.6717 86.7518 77.4785C104.582 78.4466 125.235 81.9965 137.191 89.6608",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6154 98.7369C37.9833 95.8003 33.5135 91.8713 33.6587 88.0876C33.7555 85.7802 36.2324 83.7472 40.4115 82.0852",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.49 49.5964C148.1 55.2923 156.708 63.9006 156.708 73.4124C156.708 94.0255 102.372 103.077 75.8209 103.392C67.9297 103.544 60.0514 102.69 52.376 100.851",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3096 39.7295C102.106 40.149 116.531 42.529 128.35 46.5871",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.68 29.6929C129.391 37.0507 134.11 42.4883 133.909 46.2398C133.417 55.55 95.6597 63.3031 68.6408 61.5685C49.9801 60.3584 35.2242 56.8812 34.9095 49.0797C34.6271 42.0365 60.4924 39.8341 79.3306 39.6808",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7869 226.425C38.4418 226.425 44.6474 220.104 44.6474 212.307C44.6474 204.509 38.4418 198.188 30.7869 198.188C23.132 198.188 16.9268 204.509 16.9268 212.307C16.9268 220.104 23.132 226.425 30.7869 226.425Z",
    fill: "white",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3414 216.568V216.668H27.4414L31.7538 216.668L31.7546 216.668C32.869 216.66 33.6333 216.334 34.1193 215.854C34.6046 215.376 34.8018 214.755 34.8018 214.176C34.8018 213.682 34.6736 213.305 34.4761 213.019C34.2793 212.734 34.0178 212.545 33.7598 212.421C33.5022 212.296 33.2458 212.235 33.0547 212.204C32.9768 212.191 32.9093 212.184 32.8564 212.179C32.899 212.169 32.9524 212.154 33.0137 212.135C33.1706 212.085 33.3808 212.003 33.5918 211.874C34.0153 211.614 34.448 211.156 34.448 210.386C34.448 209.817 34.2721 209.272 33.7911 208.869C33.3134 208.469 32.5496 208.223 31.4008 208.214V208.214H31.4001H27.4414H27.3414V208.314V216.568ZM28.7206 212.794H31.1137C32.0137 212.794 32.5916 212.961 32.942 213.213C33.287 213.461 33.4226 213.799 33.4226 214.176C33.4226 214.556 33.289 214.893 33.0067 215.137C32.7228 215.382 32.2772 215.542 31.6359 215.542H28.7206V212.794ZM28.7206 209.341H31.3664C32.0151 209.341 32.4408 209.454 32.7023 209.64C32.9571 209.822 33.0689 210.083 33.0689 210.42C33.0689 210.724 32.9929 211.031 32.754 211.262C32.5143 211.494 32.0934 211.668 31.3664 211.668H28.7206V209.341Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7072 107.135C42.3621 107.135 48.5673 100.814 48.5673 93.0167C48.5673 85.2193 42.3621 78.8982 34.7072 78.8982C27.0523 78.8982 20.8467 85.2193 20.8467 93.0167C20.8467 100.814 27.0523 107.135 34.7072 107.135Z",
    fill: "white",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9777 95.4991C31.4781 94.9256 31.2339 94.1717 31.1919 93.4222H38.8363H38.9363V93.3222V92.8168C38.9363 91.694 38.5976 90.6355 37.8603 89.857C37.1218 89.0773 35.9943 88.5897 34.4396 88.5897C32.9833 88.5897 31.8234 89.1001 31.0278 89.9302C30.233 90.7596 29.8082 91.9015 29.8082 93.1537C29.8082 94.4066 30.2418 95.5485 31.045 96.3776C31.849 97.2075 33.017 97.7178 34.4733 97.7178C35.5144 97.7178 36.4991 97.4875 37.269 96.9923C38.0415 96.4954 38.5933 95.7342 38.7665 94.6861L38.7857 94.5698H38.6678H37.4887H37.4031L37.3899 94.6544C37.2319 95.6654 36.1636 96.5071 34.4733 96.5071C33.303 96.5071 32.4979 96.0962 31.9777 95.4991ZM34.4396 89.8004C35.5527 89.8004 36.2874 90.1663 36.7611 90.6682C37.207 91.1407 37.4294 91.7422 37.5097 92.2957H31.2596C31.3946 91.6627 31.6809 91.0576 32.1626 90.6028C32.6724 90.1212 33.4091 89.8004 34.4396 89.8004Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.084 229.87C114.739 229.87 120.944 223.549 120.944 215.751C120.944 207.954 114.739 201.633 107.084 201.633C99.4293 201.633 93.2236 207.954 93.2236 215.751C93.2236 223.549 99.4293 229.87 107.084 229.87Z",
    fill: "white",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.558 218.314C104.058 217.741 103.814 216.987 103.772 216.237H111.416H111.516V216.137V215.632C111.516 214.509 111.178 213.45 110.44 212.672C109.702 211.892 108.574 211.405 107.02 211.405C105.563 211.405 104.403 211.915 103.608 212.745C102.813 213.575 102.388 214.716 102.388 215.969C102.388 217.222 102.822 218.363 103.625 219.193C104.429 220.022 105.597 220.533 107.053 220.533C108.095 220.533 109.079 220.302 109.849 219.807C110.622 219.31 111.173 218.549 111.347 217.501L111.366 217.385H111.248H110.069H109.983L109.97 217.469C109.812 218.48 108.744 219.322 107.053 219.322C105.883 219.322 105.078 218.911 104.558 218.314ZM107.02 212.615C108.133 212.615 108.867 212.981 109.341 213.483C109.787 213.956 110.009 214.557 110.09 215.111H103.84C103.975 214.478 104.261 213.873 104.743 213.418C105.253 212.936 105.989 212.615 107.02 212.615Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4744 149.765C105.129 149.765 111.335 143.444 111.335 135.647C111.335 127.849 105.129 121.528 97.4744 121.528C89.8195 121.528 83.6143 127.849 83.6143 135.647C83.6143 143.444 89.8195 149.765 97.4744 149.765Z",
    fill: "white",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6295 133.017V133.117H93.7295H96.7459V140.345V140.445H96.8459H98.0251H98.1251V140.345V133.117H101.141H101.241V133.017V132.091V131.991H101.141H93.7295H93.6295V132.091V133.017Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3748 53.2671C77.0297 53.2671 83.2353 46.946 83.2353 39.1486C83.2353 31.3511 77.0297 25.03 69.3748 25.03C61.7199 25.03 55.5146 31.3511 55.5146 39.1486C55.5146 46.946 61.7199 53.2671 69.3748 53.2671Z",
    fill: "white",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8202 42.0182V42.0105L66.819 42.003L66.6767 41.0778C66.703 41.1356 66.7401 41.2118 66.7893 41.3007C66.9016 41.5036 67.0774 41.774 67.3317 42.0446C67.8417 42.5871 68.6669 43.1289 69.9208 43.1289C72.2823 43.1289 73.8953 41.0629 73.8953 38.5649C73.8953 37.3155 73.5145 36.1755 72.8147 35.3461C72.1135 34.515 71.0959 34.0008 69.8366 34.0008C68.6236 34.0008 67.8193 34.5437 67.3204 35.086C67.0716 35.3565 66.8986 35.6267 66.7877 35.8295C66.7323 35.931 66.6922 36.0159 66.6658 36.0758C66.6609 36.0869 66.6565 36.0972 66.6526 36.1065H66.6517V34.4377V34.3377H66.5517H65.541H65.441V34.4377V45.7242V45.8242H65.541H66.7202H66.8202V45.7242V42.0182ZM66.8202 38.5649C66.8202 37.7679 67.0794 36.9266 67.5762 36.2868C68.0712 35.6491 68.8014 35.2116 69.7524 35.2116C70.7023 35.2116 71.3891 35.648 71.8419 36.2835C72.297 36.9223 72.5161 37.7641 72.5161 38.5649C72.5161 39.3656 72.297 40.2075 71.8419 40.8463C71.3891 41.4817 70.7023 41.9182 69.7524 41.9182C68.8014 41.9182 68.0712 41.4806 67.5762 40.843C67.0794 40.2031 66.8202 39.3619 66.8202 38.5649Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeter);
export default __webpack_public_path__ + "static/media/veter.b8c6d0b76e3374cc65cec3b48796f0f0.svg";
export { ForwardRef as ReactComponent };